import type { CreateIncidentStepId } from '../CreateIncident/createIncidentModel';
import type { ViewType } from 'components/IAP/hooks/useViewState';

/**
 * The tour runs outside React, so each host route registers the handful of
 * things it alone can do. Everything is optional: a phase whose host is not
 * mounted simply skips that behaviour.
 */
export type HwcgTourApi = {
  openCreateMenu: () => void;
  /** Opens the first plan so Add Task is on screen. */
  expandFirstPlan: () => void;
  setWizardStep: (step: CreateIncidentStepId) => void;
  applyHwcgTourDefaults: () => void;
  submitTourIncident: () => boolean;
  /** Opens the user's seat, or a seat under it, on the Planning tab. */
  openRosterSeat: () => void;
  /** Opens the first task already on the list. Returns false when there is none. */
  openFirstTask: () => boolean;
  /** Closes the task drawer so the next step can take focus. */
  closeTask: () => void;
  setTasksView: (view: ViewType) => void;
  openMenu: () => void;
  closeMenu: () => void;
  navigateTo: (href: string) => void;
  resolveRosterHref: () => string | null;
  resolveTasksHref: () => string | null;
};

let api: Partial<HwcgTourApi> = {};

/**
 * The roster tour reads this while it waits for a seat. When both the chart
 * and the page have already loaded an empty list, waiting cannot open one.
 */
export const rosterSeatLoad = {
  chartFetched: false,
  chartFetching: false,
  chartCount: 0,
  viewFetched: false,
  viewCount: -1,
};

export function registerHwcgTourApi(partial: Partial<HwcgTourApi>): () => void {
  api = { ...api, ...partial };
  return () => {
    for (const key of Object.keys(partial) as (keyof HwcgTourApi)[]) {
      if (api[key] === partial[key]) {
        delete api[key];
      }
    }
  };
}

export function getHwcgTourApi(): Partial<HwcgTourApi> {
  return api;
}
